import StarButton from "./StarButton.component";

export default StarButton;
